const MovieData = [
    {
        id:0,
        title:'KALKI 2898 AD',
        type:'Sci-Fi',
        lang:'Hindi Telgu',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/29113_k8BTHv9Z.jpg'
    },
    {
        id:1,
        title:'GODZILLA X KONG : THE ...',
        type:'Action',
        lang:'Hindi English',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/28574_9bJxdgh5.jpg'
    },
    {
        id:2,
        title:'MUNJYA',
        type:'Comedy',
        lang:'Hindi',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/28585_Pllb6ZWj.jpg'
    },
    {
        id:3,
        title:'CHANDU CHAMPION',
        type:'Sports',
        lang:'Hindi',
        src:'https://originserver-static1-uat.pvrcinemas.com/pvrcms/movie_v/28553_1SgDvpUh.jpg'
    },
    
]

export default MovieData;